import type { Installment } from "../../shared/contracts";
import { currency } from "../lib/format";

interface BalanceChartProps {
  schedule: Installment[];
  accent: string;
}

export function BalanceChart({ schedule, accent }: BalanceChartProps) {
  const width = 760;
  const height = 220;
  const maximum = schedule[0]?.openingBalance ?? 1;
  const samples = schedule.filter(
    (_item, index) => index % Math.max(1, Math.floor(schedule.length / 80)) === 0
  );
  const final = schedule.at(-1);
  if (final && samples.at(-1)?.month !== final.month) samples.push(final);

  const points = samples
    .map((item, index) => {
      const x = (index / Math.max(1, samples.length - 1)) * width;
      const y = height - (item.closingBalance / maximum) * (height - 22);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");

  return (
    <figure className="balance-chart">
      <figcaption>
        <span>Evolução do saldo devedor</span>
        <strong>{currency(maximum)} → R$ 0</strong>
      </figcaption>
      <svg
        viewBox={`0 0 ${width} ${height}`}
        role="img"
        aria-label={`Saldo devedor cai de ${currency(maximum)} até zero`}
      >
        <defs>
          <linearGradient id="balance-fill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={accent} stopOpacity="0.3" />
            <stop offset="100%" stopColor={accent} stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <line x1="0" y1={height - 1} x2={width} y2={height - 1} className="axis-line" />
        <polygon points={`0,${height} ${points} ${width},${height}`} fill="url(#balance-fill)" />
        <polyline points={points} fill="none" stroke={accent} strokeWidth="4" strokeLinecap="round" />
      </svg>
      <div className="balance-chart__scale" aria-hidden="true">
        <span>início</span>
        <span>{Math.round(schedule.length / 24)} anos</span>
        <span>{Math.round(schedule.length / 12)} anos</span>
      </div>
    </figure>
  );
}

